export interface Translations {
    startNewChat?: { [key: string]: string };
    metaMessages?: {
        [key: string]: {
            CUSTOMER: string;
            AGENT: string;
            SYSTEM: string;
            you: string;
            leftTheChat: string;
            joinedTheChat: string;
            chatEnded: string;
            chatTransferredSuccesfully: string;
            chatTransferFailed: string;
        };
    };
    endChatDialogue?: {
        [key: string]: {
            endChatText: string;
            endChatCancel: string;
            endChatConfirm: string;
        };
    };
    sendText?: { [key: string]: string };
    chatLoading?: { [key: string]: string };
    networkConnection?:  {
        [key: string]: { 
            tryAgainLoading: string; 
            networkError: string, 
            tryAgainButton: string, 
            connectingError: string, 
            chatUnavailable: string
        };
    };
    chatTranscript?: { [key: string]: string };
    chatStarted?: { [key: string]: string };
    document?: { [key: string]: string };
    poweredBy?: { [key: string]: string };
    newMessageFromChat?: { [key: string]: string };
    agentIsTyping?: { [key: string]: string };
    systemEndedMessage?: { [key: string]: string };
    sendMessage?: { [key: string]: string };
    typingAriaLabel?: { [key: string]: string };
    newMessageNotificationText?: { [key: string]: string };
    starRatingAriaLabel?: { [key: string]: string };
    chatbotAlt?: { [key: string]: string };
    noRatingAriaLabel?: { [key: string]: string };
    starAriaLabel?: { [key: string]: string };
    starsAriaLabel?: { [key: string]: string };
    quickRepliesAriaLabel?: { [key: string]: string };
    statusLabels?: {
        read?: { [key: string]: string };
        delivered?: { [key: string]: string };
        sent?: { [key: string]: string };
    },
    readAtAriaLabel?: { [key: string]: string };
    hideText?: { [key: string]: string };
    seeText?: { [key: string]: string };
    messageText?: { [key: string]: string };
    downloadLabel?: { [key: string]: string };
    receivedAtText?: { [key: string]: string };
    sentAtText?: { [key: string]: string };
    detailsText?: { [key: string]: string };
    optionsText?: { [key: string]: string };
    buttonsText?: { [key: string]: string };
    getSelectXOptionsFromY?: { [key: string]: (x: number, y: number) => string };
    says?: { [key: string]: string };
    submit?: { [key: string]: string };
    cancel?: { [key: string]: string };
}

export const translations: Translations = {
    startNewChat: {
        en: 'Start a new chat',
        de: 'Starten Sie einen neuen Chat',
        nl: 'Een nieuwe chat starten',
        da: 'Start en ny chat',
        no: 'Start en ny chat',
        sv: 'Starta en ny chatt',
        fi: 'Aloita uusi chat-keskustelu',
        cy: 'Dechrau sgwrs newydd',
    },
    metaMessages: {
        en: {
            CUSTOMER: 'Customer',
            AGENT: 'Agent',
            SYSTEM: 'System',
            leftTheChat: 'left the chat',
            joinedTheChat: 'joined the chat',
            chatEnded: 'Chat ended',
            chatTransferredSuccesfully: 'Chat Transferred Successfully',
            chatTransferFailed: 'Chat Transfer Failed',
            you: 'You',
        },
        de: {
            CUSTOMER: 'Kunde',
            AGENT: 'Ihr TUI Reiseexperte',
            SYSTEM: 'System',
            leftTheChat: 'hat den Chat verlassen',
            joinedTheChat: 'ist dem Chat beigetreten',
            chatEnded: 'Ihr Chat wurde beendet',
            chatTransferredSuccesfully: 'Ihr Chat wurde erfolgreich weitergeleitet',
            chatTransferFailed: 'Ihre Chat Weiterleitung ist fehlgeschlagen',
            you: 'Sie',
        },
        nl: {
            CUSTOMER: 'Klant',
            AGENT: 'Medewerker',
            SYSTEM: 'Systeem',
            leftTheChat: 'heeft de chat verlaten',
            joinedTheChat: 'heeft deelgenomen aan de chat',
            chatEnded: 'De chat is beëindigd',
            chatTransferredSuccesfully: 'De chat is correct doorverbonden',
            chatTransferFailed: 'Het doorverbinden van de chat is mislukt',
            you: 'Jij',
        },
        da: {
            CUSTOMER: 'Kunde',
            AGENT: 'Medarbejder',
            SYSTEM: 'System',
            leftTheChat: 'har forladt chatten',
            joinedTheChat: 'har startet chatten',
            chatEnded: 'chatten er lukket',
            chatTransferredSuccesfully: 'Chatten er blevet overført',
            chatTransferFailed: 'Chatten kunne ikke overføres',
            you: 'Dig',
        },
        no: {
            CUSTOMER: 'Kunde',
            AGENT: 'Kunderådgiver',
            SYSTEM: 'System',
            leftTheChat: 'Forlot chatten',
            joinedTheChat: 'Ble med i chatten',
            chatEnded: 'Chat avsluttet',
            chatTransferredSuccesfully: 'Chatoverføringen lyktes',
            chatTransferFailed: 'chatoverføringen mislyktes',
            you: 'Deg',
        },
        sv: {
            CUSTOMER: 'Kund',
            AGENT: 'Agent',
            SYSTEM: 'System',
            leftTheChat: 'lämnade chatten',
            joinedTheChat: 'gick med i chatten',
            chatEnded: 'Chatten avslutades',
            chatTransferredSuccesfully: 'Chatten har överförts',
            chatTransferFailed: 'Chat misslyckades',
            you: 'Du',
        },
        fi: {
            CUSTOMER: 'Asiakas',
            AGENT: 'Lomamyyjä',
            SYSTEM: 'System',
            leftTheChat: 'poistui chat-keskustelusta',
            joinedTheChat: 'liittyi chat-keskusteluun',
            chatEnded: 'Chat-keskustelu päättyi',
            chatTransferredSuccesfully: 'Chat-keskustelu yhdistettiin onnistuneesti',
            chatTransferFailed: 'Chat-keskustelun yhdistäminen epäonnistui',
            you: 'Sinä',
        },
        cy: {
            CUSTOMER: 'Cwsmer',
            AGENT: 'Asiant',
            SYSTEM: 'System',
            leftTheChat: 'Gadael y sgwrs',
            joinedTheChat: "Ymunodd â'r sgwrs",
            chatEnded: 'Diwedd y sgwrs',
            chatTransferredSuccesfully: 'Trosglwyddwyd y sgwrs yn llwyddiannus',
            chatTransferFailed: 'Trosglwyddwyd y sgwrs wedi methu',
            you: 'Ti',
        },
    },
    endChatDialogue: {
        en: {
            endChatText: 'Are you sure you want to end the chat?',
            endChatCancel: 'Cancel',
            endChatConfirm: 'End Chat',
        },
        de: {
            endChatText: 'Möchten Sie den Chat beenden?',
            endChatCancel: 'Weiter chatten',
            endChatConfirm: 'Chat beenden',
        },
        nl: {
            endChatText: 'Weet je zeker dat je de chat wilt beëindigen?',
            endChatCancel: 'Annuleren',
            endChatConfirm: 'Chat beëindigen',
        },
        da: {
            endChatText: 'Er du sikker på du vil forlade chatten?',
            endChatCancel: 'Afbryd',
            endChatConfirm: 'Slut chatten',
        },
        no: {
            endChatText: 'Er du sikker på at du vil avslutte chatten?',
            endChatCancel: 'Avbryt',
            endChatConfirm: 'Avslutt chat',
        },
        sv: {
            endChatText: 'Är du säker på att du vill avsluta chatten?',
            endChatCancel: 'Avbryt',
            endChatConfirm: 'Avsluta chat',
        },
        fi: {
            endChatText: 'Haluatko varmasti lopettaa chat-keskustelun?',
            endChatCancel: 'Peruuta',
            endChatConfirm: 'Lopeta chat',
        },
        cy: {
            endChatText: "Ydych chi'n siŵr eich bod chi am ddod â'r sgwrs i ben?",
            endChatCancel: 'Canslo',
            endChatConfirm: 'Diwedd sgwrs',
        },
    },
    sendText: {
        en: 'Send',
        de: 'Senden',
        nl: 'Verzend',
        da: 'Send',
        no: 'Send',
        sv: 'Skicka',
        fi: 'Lähetä',
        cy: 'Anfon',
    },
    chatLoading: {
        en: 'Chat is loading...',
        de: 'Chat wird geladen...',
        nl: 'Chat wordt geladen...',
        da: 'Chat indlæses...',
        no: 'Chat lastes inn...',
        sv: 'Chatten laddas...',
        fi: 'Chat latautuu...',
        cy: 'Sgwrsio llwytho...',
    },
    networkConnection: {
        en: {
            networkError: 'Due to a network error, we are unable to load live chat at this time.',
            connectingError: 'There was an error connecting you to the disconnect flow. Chat ended.',
            chatUnavailable: 'Due to extremely high traffic, live chat is unavailable at this time.',
            tryAgainLoading: 'Please try again later.',
            tryAgainButton: 'Try Again'

        },
        cy: {
            networkError: 'Oherwydd gwall gwefan, ni allwn lwytho sgwrs fyw y tro hwn.',
            connectingError: 'Roedd gwall yn eich cysylltu a’r llif datgysyllt. Sgwrs wedi’u dod i ben',
            chatUnavailable: 'Oherwydd traffig hynod o uchel, ni allwn lwytho sgwrs fyw y tro hwn.',
            tryAgainLoading: 'Os gwelwch yn dda, trio eto yn nes ymlaen.',
            tryAgainButton: 'Trio eto'
        },
    },
    chatTranscript: {
        en: 'Chat Transcript',
        cy: 'Trawsgrifiad Sgwrs',
    },
    chatStarted: {
        en: 'Chat started',
        cy: 'Sgwrs wedi dechrau',
    },
    document: {
        en: 'Document',
        cy: 'Dogfen',
    },
    poweredBy: {
        en: 'Powered by',
        cy: "Wedi'i bweri gan",
    },
    newMessageFromChat: {
        en: 'New message from chat',
        cy: 'Neges newydd o sgwrs',
    },
    agentIsTyping: {
        en: 'Agent is typing...',
        cy: 'Asiant yn teipio...',
    },
    systemEndedMessage: {
        en: 'Chat ended due to inactivity',
        cy: 'Daeth y sgwrs i ben oherwydd anweithgarwch',
    },
    sendMessage: {
        en: 'Send message',
        cy: 'Anfon neges',
    },
    typingAriaLabel: {
        en: 'typing',
        cy: 'teipio',
    },
    newMessageNotificationText: {
        en: "There's a new text from agent",
        cy: "Mae yna tecst newydd gan asiant",
    },
    starRatingAriaLabel: {
        en: 'star rating',
        cy: 'gradd seren',
    },
    chatbotAlt: {
        en: 'Chatbot Icon',
        cy: 'Eicon Chatbot',
    },
    noRatingAriaLabel: {
        en: 'No rating',
        cy: 'Dim gradd',
    },
    starAriaLabel: {
        en: 'star',
        cy: 'seren',
    },
    starsAriaLabel: {
        en: 'stars',
        cy: 'ser',
    },
    quickRepliesAriaLabel: {
        en: 'Quick replies',
        cy: 'Atebiad cyflym',
    },
    statusLabels: {
        read: {
            en: 'Read',
            cy: 'Darllen',
        },
        delivered: {
            en: 'Delivered',
            cy: 'Cyflwyno',
        },
        sent: {
            en: 'Sent',
            cy: 'Anfonwyd',
        },
    },
    readAtAriaLabel: {
        en: 'Read at',
        cy: 'Darllen yn',
    },
    hideText: {
        en: 'Hide',
        cy: 'Cuddio',
    },
    seeText: {
        en: 'See',
        cy: 'Gweld',
    },
    messageText: {
        en: 'Message',
        cy: 'Neges',
    },
    downloadLabel: {
        en: 'Download',
        cy: 'Lawrlwytho',
    },
    receivedAtText: {
        en: 'received at',
        cy: 'wedi ei dderbyn at',
    },
    sentAtText: {
        en: 'sent at',
        cy: 'wedi ei anfon at',
    },
    detailsText: {
        en: 'Details',
        cy: 'Manylion',
    },
    optionsText: {
        en: 'Options',
        cy: 'Opsiynau',
    },
    buttonsText: {
        en: 'Buttons',
        cy: 'Botymau',
    },
    says: {
        en: 'says',
        cy: 'dweud',
    },
    getSelectXOptionsFromY: {
        en: (x: number, y: number) => `Select ${x} from ${y} option${y > 1 ? 's' : ''}:`,
        cy: (x: number, y: number) => `Dewiswch ${x} o ${y > 1 ? 'opsiynau' : 'opsiwn'} ${y}:`,
    },
    cancel: {
        en: 'Cancel',
        cy: 'Canslo',
    },
    submit: {
        en: 'Submit',
        cy: 'Cyflwyno',
    },
};

export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE, 'de', 'nl', 'da', 'no', 'sv', 'fi', 'cy'];
